import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CdkStepper } from '@angular/cdk/stepper';
import { AfterViewInit, Directive, ElementRef, Host, Input, OnInit, Optional, Self } from '@angular/core';
import { TargetComponent } from '@app/shared/components/feature-target/target.component';
import { FilterInputComponent } from '@app/shared/components/filter-input/filter-input.component';
import { ModalFooterComponent } from '@app/shared/components/modal-footer/modal-footer.component';
import { SaveButtonComponent } from '@app/shared/components/save-button/save-button.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[portalAutofocus]',
  standalone: false,
})
export class AutofocusDirective implements AfterViewInit, OnInit {
  @Input({ transform: coerceBooleanProperty })
  portalAutofocus: boolean;

  constructor(
    private el: ElementRef,
    @Host() @Self() @Optional() private filterInput: FilterInputComponent<any>,
    @Host() @Self() @Optional() private modalFooter: ModalFooterComponent,
    @Host() @Self() @Optional() private ngSelect: NgSelectComponent,
    @Host() @Self() @Optional() private saveButton: SaveButtonComponent,
    @Host() @Self() @Optional() private targetComponent: TargetComponent,
    @Optional() private stepper: CdkStepper
  ) {}

  ngAfterViewInit(): void {
    if (this.portalAutofocus) {
      if (this.ngSelect != null) {
        this.focus(this.ngSelect);
      } else if (this.saveButton != null) {
        this.focus(this.saveButton);
      } else if (this.modalFooter != null) {
        this.focus(this.modalFooter);
      } else if (this.targetComponent != null) {
        this.focus(this.targetComponent);
      } else if (this.filterInput != null) {
        this.focus(this.filterInput);
      } else if (this.el.nativeElement.focus) {
        this.focus(this.el.nativeElement);
      }
    }
  }

  ngOnInit(): void {
    if (this.portalAutofocus !== undefined && this.portalAutofocus !== false) {
      this.portalAutofocus = true;
    }

    if (this.stepper != null) {
      this.stepper.selectionChange.pipe(untilDestroyed(this)).subscribe(() => {
        setTimeout(() => {
          this.ngAfterViewInit();
        }, 0);
      });
    }
  }

  private focus(el: FocusableElement): void {
    setTimeout(() => {
      el.focus();
    }, 0);
  }
}

export interface FocusableElement {
  focus(): void;
}
